import { useState } from "react";
import {
    FaSun,
    FaMoon,
    FaMobileAlt,
    FaPalette,
} from "react-icons/fa";

import "./CustomerAppearanceSettings.css";

function CustomerAppearanceSettings() {

    const [theme, setTheme] = useState("light");

    const themes = [

        {
            id: "light",
            title: "Light Theme",
            subtitle: "Bright appearance for daytime use.",
            icon: <FaSun />,
        },

        {
            id: "dark",
            title: "Dark Theme",
            subtitle: "Comfortable viewing in low light.",
            icon: <FaMoon />,
        },

        {
            id: "system",
            title: "System Default",
            subtitle: "Follow your device settings.",
            icon: <FaMobileAlt />,
        },

    ];

    return (

        <div className="appearance-page">

            <div className="appearance-header">

                <FaPalette />

                <div>

                    <h2>Appearance</h2>

                    <p>
                        Choose how HomeFoods looks.
                    </p>

                </div>

            </div>

            <div className="appearance-card">

                {

                    themes.map((item) => (

                        <label
                            key={item.id}
                            className={`theme-item ${
                                theme === item.id
                                    ? "active"
                                    : ""
                            }`}
                        >

                            <div className="theme-left">

                                <div className="theme-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h4>

                                        {item.title}

                                    </h4>

                                    <p>

                                        {item.subtitle}

                                    </p>

                                </div>

                            </div>

                            <input
                                type="radio"
                                checked={
                                    theme === item.id
                                }
                                onChange={() =>
                                    setTheme(item.id)
                                }
                            />

                        </label>

                    ))

                }

            </div>

        </div>

    );

}

export default CustomerAppearanceSettings;